import { jsx } from "react/jsx-runtime";
function StopPropagation({
  children,
  ...props
}) {
  return (
    /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */
    /* @__PURE__ */ jsx("div", {
      onClick: (event) => {
        event.stopPropagation();
      },
      onKeyDown: (event) => {
        event.stopPropagation();
      },
      ...props,
      children
    })
  );
}
export {
  StopPropagation
};
//# sourceMappingURL=StopPropagation.js.map
